<template>
    <v-app>
    
        <v-app-bar
                v-if="$vuetify.breakpoint.mdAndUp"
                app
                color="primary"
                dark
                elevate-on-scroll
        >
            <div class="d-flex align-center">
                <v-img contain @click="$router.replace('/');" src="/general/logo-header.svg" :max-width="$vuetify.breakpoint.mdAndUp ? '240px' : '150px'"></v-img>
                
            </div>

            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn class="black--text" text @click="$router.push({name: 'myAppointments'})">
                    My Appointments
                </v-btn>
                <v-btn class="black--text" text @click="$router.push({name: 'myMedicalRecords'})">
                    My Medical Records
                </v-btn>
                <v-btn class="black--text" text @click="$router.push({name: 'myQuestions'})">
                    My Questions
                </v-btn>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn text @click="goToWebsite('patient-login', false)" v-if="!userInfo">
                    Login
                </v-btn>
                <v-menu offset-y v-if="userInfo">
                    <template v-slot:activator="{ on }">
                        <v-btn class="black--text" text v-on="on" v-if="userInfo">
                            <div>
                                <div class="d-flex flex-column">
                                    <span>{{ userInfo.name }}</span>
                                    <span class="font-10">{{ moment().tz(timezone).format('z') }}</span>
                                </div>                          
                            </div>
                            
                            <v-icon right>mdi-chevron-down</v-icon>
                        </v-btn>
                    </template>
                    <v-list>                        
                        <v-list-item
                                @click="goTo('myAppointments')">
                            <v-list-item-title>My Appointments</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                                @click="goTo('myMedicalRecords')">
                            <v-list-item-title>My Medical Records</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                                @click="goTo('myQuestions')">
                            <v-list-item-title>My Questions</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                                @click="goTo('myProfile')">
                            <v-list-item-title>My Profile</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                                @click="goTo('updateProfile')">
                            <v-list-item-title>Update Profile</v-list-item-title>
                        </v-list-item>
                        <v-divider></v-divider>                        
                        <v-list-item
                                @click="goToWebsite('search-doctor?clinic=1', false)">
                            <v-list-item-title>New Clinic Appointment</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                                @click="goToWebsite('search-doctor?video=1', false)">
                            <v-list-item-title>New Video Consultation</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                                @click="goToWebsite('faq', false)">
                            <v-list-item-title>FAQs</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                                @click="logout">
                            <v-list-item-title>Logout</v-list-item-title>
                        </v-list-item>
<v-divider></v-divider>                        
                        <v-list-item
                            style="min-height:30px;"                    
                        >
                            <div style="font-size:0.8rem">
                                Your Timezone is in <b>{{ moment().tz($store.getters.timezone).format('z') }}</b>.
                            </div>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-menu offset-y v-else>
                    <template v-slot:activator="{ on }">
                        <v-btn text v-on="on" icon class="hidden-md-and-up">
                            <v-icon>mdi-menu</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item
                                @click="goTo('searchDoctor')">
                            <v-list-item-title>Book an Appointment</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-app-bar>

        <v-content v-if="$vuetify.breakpoint.mdAndUp">
            <router-view v-if="!configLoading"></router-view>
        </v-content>


        <!--        Mobile App-->
        <v-app-bar
                app
                color="primary"
                v-if="$vuetify.breakpoint.smAndDown"
                style="box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.15);"
                clipped
                dark
        >
            <v-app-bar-nav-icon color="black" @click="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title class="black--text">
                <v-img @click="$router.replace('/');" src="/general/logo-header.svg" :max-width="$vuetify.breakpoint.mdAndUp ? '240px' : '150px'"></v-img>
            </v-toolbar-title>

        </v-app-bar>
        <v-navigation-drawer
                v-model="drawer"
                app
                v-if="$vuetify.breakpoint.smAndDown"
                class="secondaryLight"
        >
            <v-list nav class="px-0">
                <v-list-item two-line @click="goTo('myProfile')">
                
                <!--
                    <v-list-item-avatar>
                        <img src="/ic_profile.svg">
                    </v-list-item-avatar>
                -->
                    <v-list-item-content>
                        <v-list-item-title>
                            <span v-if="userInfo">
                                {{ userInfo.name }}
                            </span>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            <span v-if="userInfo">
                                {{ userInfo.mobile }}
                            </span>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>

                <!-- <v-list-item @click="goTo('home')">
                    <v-list-item-action>
                        <v-icon color="darkPrimary">
                            mdi-view-dashboard
                        </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title >
                            Dashboard
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item> -->

               
                <v-list-item 
                    @click="goTo('myAppointments')">
                
                                      
                        <v-list-item-title >
                            My Appointments
                        </v-list-item-title>                    
                </v-list-item>

                <v-list-item @click="goTo('myMedicalRecords')">                    
                    
                        <v-list-item-title >
                            My Medical Records
                        </v-list-item-title>
                    
                </v-list-item>

                <v-list-item @click="goTo('myQuestions')">                                        
                        <v-list-item-title >
                            My Questions
                        </v-list-item-title>                    
                </v-list-item>

                <v-list-item @click="goTo('myProfile')">                                        
                        <v-list-item-title >
                            My Profile
                        </v-list-item-title>                    
                </v-list-item>
               
                <v-list-item @click="goTo('updateProfile')">                                        
                        <v-list-item-title >
                            Update Profile
                        </v-list-item-title>                    
                </v-list-item>
                    
                    <v-divider>
                    </v-divider>

                    <v-list-item
                                @click="goToWebsite('search-doctor?clinic=1', false)">
                            <v-list-item-title>New Clinic Appointment</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                                @click="goToWebsite('search-doctor?video=1', false)">
                            <v-list-item-title>New Video Consultation</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                                @click="goToWebsite('faq', false)">
                            <v-list-item-title>FAQs</v-list-item-title>
                        </v-list-item>



                <v-list-item @click="logout">
                                        
                        <v-list-item-title >
                            Logout
                        </v-list-item-title>
                    
                </v-list-item>

                <v-list-item
                    style="min-height:30px;"
                    class="playfair-display"
                >
                    <div style="font-size:0.7rem">
                        Your Timezone is in <b>{{ moment().tz($store.getters.timezone).format('z') }}</b>.
                    </div>
                </v-list-item>

            </v-list>
        </v-navigation-drawer>
        <v-content v-if="$vuetify.breakpoint.smAndDown">
            <transition
                    name="fade"
                    mode="out-in">
                <router-view :key="$route.fullPath"></router-view>
            </transition>
        </v-content>

        <v-footer class="lightBackground">
            <v-container class="py-0">
                <v-row>
                    <v-col cols="12" sm="12" md="4" class="text-md-left text-sm-center">
                        <span class="text-md-left text-sm-center">© HealthyAlways.com. All rights reserved.</span>
                    </v-col>

                    <v-col cols="12" sm="12" md="8" class="text-right hidden-sm-and-down">
                        <v-icon large class="mr-4" @click="openFacebook()">mdi-facebook</v-icon>
                        <v-icon large class="mr-4" @click="openTwitter()">mdi-twitter</v-icon>
                        <v-icon large class="mr-4" @click="openLinkedin()">mdi-linkedin</v-icon>
                        <v-icon large @click="openYoutube()">mdi-youtube</v-icon>
                    </v-col>
                    
                    <v-col cols="12" sm="12" md="8" class="text-center hidden-md-and-up">
                        <v-icon medium class="mr-4" @click="openFacebook()">mdi-facebook</v-icon>
                        <v-icon medium class="mr-4" @click="openTwitter()">mdi-twitter</v-icon>
                        <v-icon medium class="mr-4" @click="openLinkedin()">mdi-linkedin</v-icon>
                        <v-icon medium @click="openYoutube()">mdi-youtube</v-icon>
                    </v-col>
                </v-row>
            </v-container>
        </v-footer>
        <v-snackbar @click="notificationClicked(snackbar.payload)" top right v-model="showSnackbar" :color="snackbar.color">{{snackbar.message}}</v-snackbar>
    </v-app>

</template>

<script>
    import {mapGetters} from 'vuex'
    import * as linkutils from './LinkUtils.js'

    export default {
        name: 'App',
        computed: {
            ...mapGetters([
                'accessToken',
                'userInfo',
                'timezone',
                'snackbar',
                'config'
            ]),
        },
        data: () => ({
            drawer: false,
            showSnackbar:false,
            configLoading:false
        }),
        methods: {
            openFacebook(){
                window.open("https://www.facebook.com/HealthyAlways/")
            },
            openTwitter(){
                window.open("https://twitter.com/HealthyAlways1")
            },
            openLinkedin(){
                window.open("https://www.linkedin.com/company/healthyalways-com/")
            },
            openYoutube(){
                window.open("https://www.youtube.com/user/healthyalwaysdr")
            },
            notificationClicked(data){
                
                var module = data.module
                var action = data.action
                var record_id = data.record_id
                // var parent_module = data.parent_module
                // var parent_record_id = data.parent_module_id

                var redirectUrl = ""
                if(module=='appointment'){    
                    if(action=='video_call'){
                        redirectUrl = linkutils.appointmentCall(record_id);
                    }
                    else      
                        redirectUrl = linkutils.appointment(record_id);
                }
                else if(module=='record'){              
                    redirectUrl = linkutils.medicalRecord(record_id)
                }
                else
                    redirectUrl = "/"
                
                window.open(redirectUrl, '_blank')                
            },
            initFirebase(){
                try{
                    window.subscribeToken();
                    window.firebase_messaging.onMessage((payload) => {
                            console.log("NOTIFICATION RECEIVED")

                        if(payload.data && payload.data.title && payload.data.body){
                            
                            this.firebaseNotificationReceived(payload)
                            this.snackbar.message = payload.data.body
                            this.showSnackbar = true
                            this.snackbar.action= payload.data.action
                            this.snackbar.payload= payload.data
                        }
                    });
                }
                catch(e){
                    console.log("n")
                }

            },
            goTo(routeName) {
                this.$router.push({name: routeName});
            },
            firebaseNotificationReceived(notification) {
                this.$store.dispatch('notificationReceived', notification);
            },
            logout() {
                this.$store.dispatch('userLogout')                
                window.deleteToken()
                var newURL = new URL(process.env.VUE_APP_WEBSITE_URL)                                
                    newURL.searchParams.set('logout', 1);                            

                window.location.href = newURL.href
            },
            getAppConfig(){
                this.configLoading = true
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/app-config`)
                .then((response) => {
                    if(response.data.status == 1){                        
                        this.$store.dispatch('storeConfig',response.data.data)
                        console.log("NEW CONFIG SAVED")                        
                        console.log(this.$store.getters.config)                        
                    }
                    
                })
                .catch((error) => {
                    console.log(error)
                })
                .finally(()=>{
                    this.configLoading = false
                })
            }
        },
        created () {
            this.$store.subscribe((mutation, state) => {
                console.log("MUTATION")
                    console.log(mutation.type)
                if (mutation.type === 'showSnackbar') {
                                    
                    this.snackbar.message = state.snackbar.message
                    this.snackbar.color = state.snackbar.color
                    this.showSnackbar = true
                }
            })
        },
        mounted(){
            this.getAppConfig()
            this.initFirebase()
        }
    };
</script>

<style scoped>
    footer .v-icon:hover {
        color: #F76056 !important;
    }
</style>